import React from "react";
import { HiOutlineMagnifyingGlass } from "react-icons/hi2";

/**
 * Figma search input (va4cf / ZfjMR): rounded 10, muted fill, 9×11 padding, 13px medium placeholder.
 */
const TimesheetSearchField = ({
  value = "",
  onChange,
  placeholder = "Search…",
  className = "",
  autoFocus = false,
  onKeyDown,
}) => {
  return (
    <div
      className={`flex w-full items-center gap-2 rounded-[10px] border border-[#E5E7EB] bg-[#F8FAFC] px-[11px] py-[9px] box-border transition-colors focus-within:border-[#C5D4EA] focus-within:ring-1 focus-within:ring-[#4A6BB6]/15 ${className}`}
    >
      <HiOutlineMagnifyingGlass
        className="h-4 w-4 shrink-0 text-[#94A3B8]"
        aria-hidden
      />
      <input
        type="search"
        enterKeyHint="search"
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
        onKeyDown={onKeyDown}
        placeholder={placeholder}
        autoComplete="off"
        autoFocus={autoFocus}
        className="min-w-0 flex-1 border-0 bg-transparent p-0 text-[13px] font-medium leading-normal text-[#0F172A] placeholder:text-[13px] placeholder:font-medium placeholder:text-[#94A3B8] focus:outline-none focus:ring-0 [&::-webkit-search-cancel-button]:hidden"
      />
    </div>
  );
};

export default TimesheetSearchField;
